export default
{
    namespaced: true,
    
    state:
    {
        sentPushNotifications: []
    },

    mutations:
    {
        setSentPushNotifications (state, notifications) 
        {
            for (const notification of notifications)
            {
                const sameId = state.sentPushNotifications.find(n => n.id == notification.id)
                if (sameId) continue

                state.sentPushNotifications.push(notification)
            }
        }
    },

    getters:
    {
        notificationsByDate: (state, getters, rootState, rootGetters) =>
        {
            const byDate = {}
            const addElement = (element, date, type) =>
            {
                date = new Date(date)
                date.setUTCHours(0, 0, 0, 0)
                if (!byDate[date]) byDate[date] = []
                byDate[date].push({type, element})
            }

            const pushes = rootState.notifications.sentPushNotifications
            const reports = rootState.reports.reportsList
            const lostObjects = rootState.lostObjects.objectsList
            const lostPets = rootState.lostPets.petsList
            const actualities = rootState.actualities.actualityList
            const events = rootState.events.eventList
            const storeNotifications = rootState.storeNotifications.notificationList
        
            for (const push of pushes)
            {
                addElement(push, push.date, 'push')
            }
            for (const report of reports)
            {
                addElement(report, report.date, 'report')
            }
            for (const lostObject of lostObjects)
            {
                addElement(lostObject, lostObject.date, 'lostObject')
            }
            for (const lostPet of lostPets)
            {
                addElement(lostPet, lostPet.date, 'lostPet')
            }
            for (const actuality of actualities)
            {
                addElement(actuality, actuality.date, 'actuality')
            }
            for (const event of events)
            {
                addElement(event, event.date, 'event')
            }
            for (const notif of storeNotifications)
            {
                addElement(notif, notif.date, 'storeNotification')
            }
            
            const ordered = Object.keys(byDate).sort((a, b) => new Date(b) - new Date(a))
            const sorted = {}

            for (let date of ordered)
            {
                const orderedElements = byDate[date].sort((a, b) => new Date(b.element.date) - new Date(a.element.date))
                sorted[date] = orderedElements
            }

            return sorted
        },
    }
}


// WEBPACK FOOTER //
// ./src/stores/notifications.js